export default "__VITE_ASSET__245a6508__"